// extracted by mini-css-extract-plugin
export default {"MainBox":"checkout_MainBox__TUSS1","formBox":"checkout_formBox__UKYhO","forms":"checkout_forms__aLglt","pay":"checkout_pay__3dp4o","Table":"checkout_Table__H3-oh"};